import * as yup from 'yup';

// Copied from CompanyDetailsDE.schema.ts (required) + mobile positive-amount guard.
export const turnoverSchema = yup.object().shape({
  last12MonthsTurnover: yup
    .string()
    .required('benötigt')
    .test('is positive', 'benötigt', (value) => {
      const digits = (value ?? '').replace(/[^0-9]+/g, '');
      return Number(digits) > 0;
    }),
});
